import { Bug, CheckSquare, User, Clock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const typeConfig = {
  Task: { icon: CheckSquare, color: 'border-l-blue-500', badge: 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400' },
  Bug: { icon: Bug, color: 'border-l-red-500', badge: 'bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-400' },
  'User Story': { icon: null, color: 'border-l-purple-500', badge: 'bg-purple-100 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400' },
};

const stateToColumn = {
  'New': 'TODO',
  'Active': 'IN_PROGRESS',
  'Resolved': 'IN_REVIEW',
  'Closed': 'DONE',
};

export function mapAdoStateToColumn(state, tags = '') {
  if (tags.includes('Blocked')) return 'BLOCKED';
  if (tags.includes('In Review')) return 'IN_REVIEW';
  return stateToColumn[state] || 'TODO';
}

export default function WorkItemCard({ item, onDragStart, onDragEnd, compact = false, parentTitle, draggable = true }) {
  const config = typeConfig[item.type] || typeConfig.Task;
  const Icon = config.icon;

  return (
    <div
      draggable={draggable}
      onDragStart={(e) => {
        e.dataTransfer.setData('text/plain', JSON.stringify({ ado_id: item.ado_id, type: item.type }));
        e.dataTransfer.effectAllowed = 'move';
        onDragStart?.(item.ado_id);
      }}
      onDragEnd={() => onDragEnd?.()}
      className={`bg-white dark:bg-white/5 border border-[#e3e3e3] dark:border-white/10 border-l-4 ${config.color}
        ${compact ? 'p-2' : 'p-3'} ${draggable ? 'cursor-grab active:cursor-grabbing' : ''} hover:border-[#98139C] transition-colors`}
    >
      <div className="flex items-start gap-2">
        {Icon && <Icon size={14} className="text-gray-500 dark:text-gray-400 mt-0.5 flex-shrink-0" />}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 mb-1">
            <Badge className={`text-[10px] rounded-none px-1.5 py-0 ${config.badge}`}>
              {item.type}
            </Badge>
            {item.priority && (
              <Badge className="text-[10px] rounded-none px-1.5 py-0 bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400">
                P{item.priority}
              </Badge>
            )}
          </div>
          <p className={`text-[#30302F] dark:text-white ${compact ? 'text-xs' : 'text-sm'} font-medium truncate`}>
            {item.title}
          </p>
          {parentTitle && (
            <p className="text-[10px] text-gray-400 dark:text-gray-500 truncate mt-0.5">
              &uarr; {parentTitle}
            </p>
          )}
          <div className="flex items-center gap-2 mt-1.5">
            {item.assigned_to && (
              <span className="flex items-center gap-1 text-[11px] text-gray-500 dark:text-gray-400">
                <User size={10} /> {item.assigned_to.split(' ')[0]}
              </span>
            )}
            {item.remaining_work != null && (
              <span className="flex items-center gap-1 text-[11px] text-gray-500 dark:text-gray-400">
                <Clock size={10} /> {item.remaining_work}h
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
